// extracted by mini-css-extract-plugin
module.exports = {"heading":"styles_heading__3AgLm","ids":"styles_ids__3q8bu","imgContainer":"styles_imgContainer__1NZVS","name":"styles_name__3xDSR"};